import { render, staticRenderFns } from "./block3.vue?vue&type=template&id=00ae0bb1&scoped=true&"
import script from "./block3.vue?vue&type=script&lang=js&"
export * from "./block3.vue?vue&type=script&lang=js&"
import style0 from "./block3.vue?vue&type=style&index=0&id=00ae0bb1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ae0bb1",
  null
  
)

export default component.exports